import React from 'react';
import Marquee from "react-fast-marquee";
import { Box, Typography, Link } from '@mui/material';
import { styled } from '@mui/system';
import { partnersData } from '../utils/BeadsData';

// Custom styled component for image thumbnails
const Thumb = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  '& img': {
    width: '100%',
    maxWidth: '300px',
    height: '140px',
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  [theme.breakpoints.down('md')]: {
    '& img': {
      maxWidth: '220px',
      height: '110px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    '& img': {
      maxWidth: '200px',
      height: '90px',
    },
  },
}));

const Partners = ({ title, subtitle }) => {
  return (
    <Box bgcolor="#246BFD" color="#fff" py={5} mt={2} mb={5}>
      <Typography variant="h3" component="h3" gutterBottom textAlign="center" sx={{ fontWeight: 600, pt: 1 }}>
        {title || 'Our Partners'}
      </Typography>
      <Typography variant="body1" sx={{ textAlign: 'center', px: 1, color: '#fff'}}>
        {subtitle || 'WE ARE VERY GRATEFUL FOR THE SUPPORT OF OUR LONG-TIME CORPORATE PARTNERS :'}
      </Typography>

      <Box py={5}>
        <Marquee gradient={false}>
          {partnersData.map((partner, index) => (
            <Thumb key={index}>
              <Link href={partner.href} target="_blank" rel="noopener noreferrer">
                <img src={partner.src} alt={partner.alt} />
              </Link>
            </Thumb>
          ))}
        </Marquee>
      </Box>
    </Box>
  );
}

export default Partners;
